import { render, staticRenderFns } from "./InputValor.vue?vue&type=template&id=4df4fb3b&scoped=true&"
import script from "./InputValor.vue?vue&type=script&lang=js&"
export * from "./InputValor.vue?vue&type=script&lang=js&"
import style0 from "./InputValor.vue?vue&type=style&index=0&id=4df4fb3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df4fb3b",
  null
  
)

export default component.exports